import cloneDeep from 'lodash/cloneDeep';

import { parseJSON } from '@webapp/common/lib/utils';

import type { HistoryOrder, OrderStatus } from './history-order';
import { initialHistoryOrder } from './history-order';
import type { OrderData, OrderDataRequest } from './order-data';

export const mapHistoryOrder = ({
    AMOUNT,
    EMAIL,
    ID,
    INV_DATE,
    INV_NUM,
    INV_TEXT,
    ITEMS,
    PHONE,
    STATUS,
}: any): HistoryOrder => ({
    ...cloneDeep(initialHistoryOrder),
    id: ID,
    invNum: INV_NUM,
    desc: INV_TEXT,
    created_at: INV_DATE,
    sum: AMOUNT,
    status: String(STATUS) as OrderStatus,
    email: EMAIL,
    phone: PHONE,
    items: parseJSON(ITEMS),
});

export const reverseMapOrderData = ({
    city,
    companyName,
    country,
    email,
    inn,
    kpp,
    name,
    ogrn,
    phone,
    address,
    type,
    zipCode,
}: OrderData): OrderDataRequest => ({
    USER_TYPE: type,
    COMPANY_NAME: companyName,
    INN: inn,
    KPP: kpp,
    OGRN: ogrn,

    COUNTRY: country,
    ZIPCODE: zipCode,
    CITY: city,

    ADDRESS: address,

    NAME: name,

    EMAIL: email,
    PHONE: phone,
});
